import { render, staticRenderFns } from "./callServiceItems.vue?vue&type=template&id=34b25b97&scoped=true&"
import script from "./callServiceItems.vue?vue&type=script&lang=js&"
export * from "./callServiceItems.vue?vue&type=script&lang=js&"
import style0 from "./callServiceItems.vue?vue&type=style&index=0&id=34b25b97&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b25b97",
  null
  
)

export default component.exports